import { useEffect, useRef } from "react";

import { REFRESH_INTERVAL_MS } from "./format";

/**
 * Runs `task` now and then every 15 s. Ticks are skipped while the tab is
 * hidden, and one refresh runs when it becomes visible again.
 */
export function usePolling(
  task: () => void,
  intervalMs: number = REFRESH_INTERVAL_MS,
): void {
  const latest = useRef(task);
  useEffect(() => {
    latest.current = task;
  });
  useEffect(() => {
    latest.current();
    const timer = setInterval(() => {
      if (document.visibilityState !== "hidden") latest.current();
    }, intervalMs);
    const onVisible = () => {
      if (document.visibilityState === "visible") latest.current();
    };
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      clearInterval(timer);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [intervalMs]);
}
